<template>
  <a
    class="link-button"
    :class="{ decoration, disabled }"
    href="Javascript:void(0)"
    @click.prevent="handleClick"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    decoration: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick () {
      if (this.disabled) return
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="scss">
.link-button {
  font-size: 24px;
  color: #10aeff;
  text-decoration: none;

  &.decoration {
    text-decoration: underline;
  }

  &.disabled {
    color: #7f7f7f;
  }
}
</style>
